import { VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { useDadosServidoresQuery } from 'graphql/hooks.generated'
import React from 'react'
import Permissions from 'types/Permissions'

import { ServidoresBox } from './ServidoresBox'

export const ServidoresView = () => {
  const { data, refetch } = useDadosServidoresQuery()
  return (
    <>
      {data && data.servidores && (
        <VFlow vSpacing={2}>
          <CheckPermission permission={Permissions.configuracaoDeInstalacao.configurarConexaoComInternet}>
            <ServidoresBox
              internetConnection={data.servidores.internet.habilitado}
              dadosServidor={data.servidores.dadosServidor}
              servidorSMTP={data.servidores.servidorSMTP}
              load={refetch}
            />
          </CheckPermission>
        </VFlow>
      )}
    </>
  )
}
